import type { HTMLAttributes } from "react"

/**
 * A `data-guide-target` attribute for an antd `Table` column's
 * `onHeaderCell`/`onCell` — those are typed as `HTMLAttributes & TdHTMLAttributes`
 * with no index signature for arbitrary `data-*` keys, so a plain object
 * literal has "no properties in common" with the expected type. The double
 * cast is the standard escape hatch for that: safe here because the value is
 * only ever spread onto a real `<th>`/`<td>`, which happily accepts any
 * `data-*` attribute at runtime regardless of what the antd types declare.
 */
export const tableGuideAnchor = (target: string): HTMLAttributes<HTMLElement> =>
  ({ "data-guide-target": target }) as unknown as HTMLAttributes<HTMLElement>
